import { render } from "./AddMedia.vue?vue&type=template&id=d21ec2be&scoped=true"
import script from "./AddMedia.vue?vue&type=script&lang=js"
export * from "./AddMedia.vue?vue&type=script&lang=js"

import "./AddMedia.vue?vue&type=style&index=0&id=d21ec2be&lang=scss&scoped=true"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d21ec2be"]])

export default __exports__